import * as React from 'react';
import { UsersContainer } from '../../containers';

const UsersPage: React.FC = () => (
  <UsersContainer />
);

export default UsersPage;
